export const isMobile = window.matchMedia(
  "only screen and (max-width: 576px)"
).matches;
